import * as C from './constants'

export const outgoingCallSourceSet = (source) => (dispatch, getState) => {
  if (source !== getState().analytics.outgoingCallSource) {
    dispatch({
      type: C.OUTGOING_CALL_SOURCE_SET,
      payload: source,
    })
  }
}

export const callBackOutgoingCall = () => (dispatch) => {
  dispatch(outgoingCallSourceSet(C.OUTGOING.BACK))
}

export const dialedOutgoingCall = () => (dispatch) => {
  dispatch(outgoingCallSourceSet(C.OUTGOING.CLICKED))
}

export const contactOutgoingCall = () => (dispatch) => {
  dispatch(outgoingCallSourceSet(C.OUTGOING.CONTACT))
}

export const pastedOutgoingCall = () => (dispatch) => {
  dispatch(outgoingCallSourceSet(C.OUTGOING.PASTED))
}

export const typedOutgoingCall = () => (dispatch) => {
  dispatch(outgoingCallSourceSet(C.OUTGOING.TYPED))
}

export const outgoingCallSourceClear = () => (dispatch, getState) => {
  if (getState().analytics.outgoingCallSource !== C.OUTGOING.UNKNOWN) {
    dispatch({
      type: C.OUTGOING_CALL_SOURCE_CLEAR,
    })
  }
}
